import React, { FC } from 'react';
import styles from './Categories.module.scss';
import { Partners } from './Partners';
import { FirstMonthPromotion } from './FirstMonth';
import { CategoriesSlider } from './CategoriesSlider';
import { CategoriesModel } from '../../../pages/home/query/types';
import Spinner from '../../../shared/Spinner/Spinner';
import { useTranslation } from 'react-i18next';

interface CategoriesI {
  categories: CategoriesModel[];
}

const Categories: FC<CategoriesI> = ({ categories }) => {
  const {
    i18n: { language },
  } = useTranslation();

  if (!categories) return <Spinner />;

  const firstCategories = categories.slice(0, Math.floor(categories.length / 2));
  const secondCategories = categories.slice(Math.floor(categories.length / 2));


  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <header>
          <h3>KATEGORIEN</h3>
          <a className={styles.allCategories} href={`/${language}/movies?page=1`}>
            {'ALLE KATEGORIEN >>'}
          </a>
          <a className={styles.all} href={`/${language}/movies?page=1`}>
            {'ALLE >>'}
          </a>
        </header>
        <CategoriesSlider categories={firstCategories} />
        <div className={styles.divider} />
        <CategoriesSlider categories={secondCategories} />
        <FirstMonthPromotion />
      </div>

      <Partners />
    </div>
  );
};

export default Categories;
